import { ExperteBlockung } from '../dtos';

export const getExperteGesellschaftName = (gesellschaft?: ExperteBlockung['experte']['gesellschaft']): string => {
  if (!gesellschaft?.gesellschaftId) {
    return '-';
  }

  if (gesellschaft.type === 'SINGLE_MEMBER_ORGANIZATION') {
    return 'Einpersonengesellschaft';
  }

  return gesellschaft.name;
};
